import { render, staticRenderFns } from "./mission.vue?vue&type=template&id=2c30621d&scoped=true&"
import script from "./mission.vue?vue&type=script&lang=js&"
export * from "./mission.vue?vue&type=script&lang=js&"
import style0 from "./mission.vue?vue&type=style&index=0&id=2c30621d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c30621d",
  null
  
)

export default component.exports